// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.summary-card {
  display: inline-block;
  justify-content: space-between;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16);
  border-radius: 3px;
  width: 30%;
  padding: 10px 10px;
  min-height: 100%;
}

.footerhead {
  padding-top: 15px;
  display: flex;
  justify-content: space-between;
  flex-direction: row;
}

.card-footer {
  height: 50%;
  width: auto;
}

.title {
  color: rgb(11, 54, 95);
  text-align: center;
  margin-bottom: 0;
  font-size: 2vw;
}

.subtitle {
  color: rgb(11, 54, 95);
  text-align: center;
  font-size: 1.5vw;
  margin-top: 0;
}

.data {
  height: 50%;
  width: 100%;
  text-align: center;
  margin-bottom: 30px;
}

.summary-data {
  color: rgb(11, 54, 95);
}

.summary-data-title-size {
  font-size: 3vw;
}

.summary-data-filing-period-size {
  font-size: 2vw;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/committee-summary/committee-summary.component.scss"],"names":[],"mappings":"AAAA;EACI,qBAAA;EACA,8BAAA;EACA,yCAAA;EACA,kBAAA;EACA,UAAA;EACA,kBAAA;EACA,gBAAA;AACJ;;AAEA;EACI,iBAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;AACJ;;AAEA;EACI,WAAA;EACA,WAAA;AACJ;;AAEA;EACI,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;AACJ;;AAEA;EACI,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,aAAA;AACJ;;AAEA;EACI,WAAA;EACA,WAAA;EACA,kBAAA;EACA,mBAAA;AACJ;;AAEA;EACI,sBAAA;AACJ;;AAEA;EACI,cAAA;AACJ;;AAEA;EACI,cAAA;AACJ","sourcesContent":[".summary-card {\n    display: inline-block;\n    justify-content: space-between;\n    box-shadow: 0 3px 6px rgba(0 0 0 / 16%);\n    border-radius: 3px;\n    width: 30%;\n    padding: 10px 10px;\n    min-height: 100%;\n}\n\n.footerhead {\n    padding-top: 15px;\n    display: flex;\n    justify-content: space-between;\n    flex-direction: row;\n}\n\n.card-footer {\n    height: 50%;\n    width: auto;\n}\n\n.title {\n    color: rgb(11, 54, 95);\n    text-align: center;\n    margin-bottom: 0;\n    font-size: 2vw;\n}\n\n.subtitle {\n    color: rgb(11, 54, 95);\n    text-align: center;\n    font-size: 1.5vw;\n    margin-top: 0;\n}\n\n.data {\n    height: 50%;\n    width: 100%;\n    text-align: center;\n    margin-bottom: 30px;\n}\n\n.summary-data {\n    color: rgb(11, 54, 95);\n}\n\n.summary-data-title-size {\n    font-size: 3vw;\n}\n\n.summary-data-filing-period-size {\n    font-size: 2vw;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
